jQuery(document).ready(function ($) {







//     let level;
//     let className;
//     let levelThird;
//     let classNameThird;

//     // JS Breakpoints
//     var isBreakPoint = function (bp) {
//         var bps = [0, 1024, 3500],
//                 w = $(window).width(),
//                 min, max
//         for (var i = 0, l = bps.length; i < l; i++) {
//             if (bps[i] === bp) {
//                 min = bps[i - 1] || 0
//                 max = bps[i]
//                 break
//             }
//         }
//         return w > min && w <= max
//     }

//     if (isBreakPoint(3500)) {
//         // console.log('wider than 1024');
//         $('.main-navigation__first-level-ul li a').hover(
//                 function () {
//                     // Reset
//                     $('.main-navigation__second-level-ul').removeClass('main-navigation__second-level-ul--show');
//                     $('.main-navigation__third-level-ul').removeClass('main-navigation__third-level-ul--show');
//                     $('.main-navigation__first-level-ul li a').removeClass('show');

//                     // Hover class other
//                     $('.main-navigation__first-level').addClass('main-navigation__first-level--active');

//                     $(this).addClass('show');
//                     level = $(this).data('level');
//                     if (level) {
//                         className = '.level__2--' + level;
//                         $('.main-navigation__second-level').find(className).addClass('main-navigation__second-level-ul--show');
//                     }
//                 }, function () {

//                 }
//         );

//         $('.main-navigation__second-level-ul li a').hover(
//                 function () {
//                     // Reset
//                     $('.main-navigation__third-level-ul').removeClass('main-navigation__third-level-ul--show');
//                     $('.main-navigation__second-level-ul li a').removeClass('show');

//                     $(this).addClass('show');
//                     levelThird = $(this).data('level');
//                     if (levelThird) {
//                         classNameThird = '.level__3--' + levelThird;
//                         $('.main-navigation__third-level').find(classNameThird).addClass('main-navigation__third-level-ul--show');
//                     }
//                 }, function () {

//                 }
//         );

//         // Remove all show classes after hovering out of .container
//         $('.main-navigation > .container').hover(
//                 function () {

//                 }, function () {
//                     $('.main-navigation__first-level-ul li a').removeClass('show');
//                     $('.main-navigation__second-level-ul li a').removeClass('show');
//                     $('.main-navigation__third-level-ul').removeClass('main-navigation__third-level-ul--show');
//                     $('.main-navigation__second-level-ul').removeClass('main-navigation__second-level-ul--show');
//                     $('.main-navigation__first-level').removeClass('main-navigation__first-level--active');
//                 }
//         );
//     }

    // Open menu
    $('.header__menu-button').on('click', function () {
        $('.main-navigation').addClass('main-navigation--show');
    });

    // Close menu
    $('.main-navigation__close').on('click', function () {
        $('.main-navigation').removeClass('main-navigation--show');
    });

    // Open modal
    $('.header__more-info, .more-info-modal').on('click', function () {
        $('.modal').addClass('modal--show');
        $('body, html').css('overflow', 'hidden');
    });

    // Close modal
    $('.modal__close').on('click', function () {
        $('.modal').removeClass('modal--show');
        $('body, html').css('overflow', 'unset');
    });

//     //
//     //  Mobile
//     //
//     // First level to second
//     if (isBreakPoint(1024)) {
//         // console.log('1024 or smaller');
//         $('.main-navigation__first-level .main-navigation__block-button').on('click', function (e) {
//             e.preventDefault();
//             level = $(this).parent().data('level');
//             if (level) {
//                 className = '.level__2--' + level;
//                 $('.main-navigation__second-level').find(className).addClass('main-navigation__second-level-ul--show');
//             }
//             $('.main-navigation__first-level-ul').addClass('main-navigation__first-level-ul--hide');

//             // Back buttons
//             $('.main-navigation__mobile-back-second').addClass('main-navigation__mobile-back-second--show');
//         });

//         $('.main-navigation__mobile-back-second').on('click', function (e) {
//             e.preventDefault();
//             $('.main-navigation__first-level-ul').removeClass('main-navigation__first-level-ul--hide');
//             $('.main-navigation__second-level-ul').removeClass('main-navigation__second-level-ul--show');

//             // Back buttons
//             $('.main-navigation__mobile-back-second').removeClass('main-navigation__mobile-back-second--show');
//         });

//         // Second level to third
//         $('.main-navigation__second-level .main-navigation__second-level-block-button').on('click', function (e) {
//             e.preventDefault();
//             thirdLevel = $(this).parent().data('level');
//             if (thirdLevel) {
//                 thirdClassName = '.level__3--' + thirdLevel;
//                 $('.main-navigation__third-level').find(thirdClassName).addClass('main-navigation__third-level-ul--show');
//             }
//             $('.main-navigation__second-level-ul').addClass('main-navigation__second-level-ul--hide');

//             // Back buttons
//             $('.main-navigation__mobile-back-second').removeClass('main-navigation__mobile-back-second--show');
//             $('.main-navigation__mobile-back-third').addClass('main-navigation__mobile-back-third--show');
//         });

//         $('.main-navigation__mobile-back-third').on('click', function (e) {
//             e.preventDefault();
//             $('.main-navigation__third-level-ul').removeClass('main-navigation__third-level-ul--show');
//             $('.main-navigation__second-level-ul').removeClass('main-navigation__second-level-ul--hide');

//             // Back buttons
//             $('.main-navigation__mobile-back-third').removeClass('main-navigation__mobile-back-third--show');
//             $('.main-navigation__mobile-back-second').addClass('main-navigation__mobile-back-second--show');
//         });
//     }

});
